import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { actFecthYearEndWrap, setHasYearEnd, setYearEndData } from "../../../actions";
import config from "../../../config/config";
import callApi from "../../../utils/apiCaller";
import StarYearEndWrap from "./StarYearEndWrap";
import YearEndWrap from "./YearEndWrap";
import YearEndWrapModal from "./YearEndWrapModal";
import "./yearwrap.scss";

const YearWrapActivator = () => {
  const { yearEndWrap, hasYearEnd } = useSelector((state) => state.commonSetting);
  const dispatch = useDispatch();
  const hasModal =
    config.checkLocalStorage && !localStorage.getItem("st_year_end_wrap_2022");
  const hasYearEndWrap =
    config.checkLocalStorage &&
    localStorage.getItem("st_year_end_wrap_2022") == 1;

  const getYearEndData = async () => {
    const res = await callApi("get", { action: "getDataYearEnd" });
    const listStoreDev = [
      "dev-facebook-chat.myshopify.com",
      "huongpt-cta.myshopify.com",
    ];

    const hasData = res?.data?.data;
    const show =
      res?.data?.data?.order_synced != 0 || listStoreDev.includes(config.shop);

    if (hasData && show) {
      dispatch(setHasYearEnd(true));
      dispatch(setYearEndData(res.data.data));
    }
  };

  useEffect(() => {
    getYearEndData();
  }, []);

  // useEffect(() => {
  //   if (window.location.href.includes("customerio")) {
  //     dispatch(actFecthYearEndWrap(true));
  //   }
  // }, [window]);

  return (
    hasYearEnd && (
      <div className="year-end-wrap">
        {hasModal && <YearEndWrapModal />}
        {hasYearEndWrap && <StarYearEndWrap />}
        {yearEndWrap && <YearEndWrap />}
      </div>
    )
  );
};

export default YearWrapActivator;
